const createJsonForNewResource = (newResourceState) => {
    let newJson = {
        "resourceType": newResourceState.resourceType,
        "meta": newResourceState.meta,
        "title": newResourceState.title
    };
    if (newResourceState.resourceType === "ActivityDefinition" ||
        newResourceState.resourceType === "DeviceDefinition" ||
        newResourceState.resourceType === "EvidenceVariable" ||
        newResourceState.resourceType === "Measure" ||
        newResourceState.resourceType === "PlanDefinition" ||
        newResourceState.resourceType === "Questionnaire" ||
        newResourceState.resourceType === "ResearchStudy" ||
        newResourceState.resourceType === "ResearchSubject" ||
        newResourceState.resourceType === "ValueSet"
    ) {
        newJson.status = "active";
    } else if (newResourceState.resourceType === "Citation") {
        newJson.status = "active";  
    if (newResourceState.citedArtifactClassificationToAdd) {
        newJson.citedArtifact = { classification: [newResourceState.citedArtifactClassificationToAdd] };
    }
    } else if (newResourceState.resourceType === "CodeSystem") {
        newJson.status = "active";
        newJson.content = "example";
        newJson.concept = [];
    } else if (newResourceState.resourceType === "Evidence") {
        newJson.status = "active";
        newJson.variableDefinition = [];
    } else if (newResourceState.resourceType === "Composition") {
        newJson.status = "final";
        newJson.section = newResourceState.section || [];
    } else if (newResourceState.resourceType === "Group") {
        newJson.membership = "conceptual";
    } else if (newResourceState.resourceType === "Library") {
        newJson.status = "active";
        newJson.type = "asset-collection";
    } else if (newResourceState.resourceType === "List") {
        newJson.status = "current";
        newJson.mode = "snapshot";
    } else if (newResourceState.resourceType === "Practitioner") {
        newJson.name = { "text": newResourceState.title };
        delete newJson.title;
    } else if (newResourceState.resourceType === "PractitionerRole") {
        newJson.display = newResourceState.title;
        delete newJson.title;
    } else if (newResourceState.resourceType === "Organization") {
        newJson.name = newResourceState.title;
        delete newJson.title;
    } else if (newResourceState.resourceType === "DocumentReference") {
        newJson.status = "current";
        newJson.content = [];
    }

    if (newResourceState.typeValue) {
        newJson.type = newResourceState.typeValue;
    }
    if (newResourceState.categoryToAdd) {
        newJson.category = [newResourceState.categoryToAdd];
    }
    if (newResourceState.useContextToAdd) {
        newJson.useContext = [newResourceState.useContextToAdd];
    }
    if (newResourceState.membershipValue) {
        newJson.membership = newResourceState.membershipValue;
    }
    if (typeof newResourceState.actualValue === "boolean") {
        newJson.actual = newResourceState.actualValue;
    }
    if (newResourceState.definitionValue) {
        newJson.definition = newResourceState.definitionValue;
    }
    if (newResourceState.handlingValue) {
        newJson.handling = newResourceState.handlingValue;
    }
    if (newResourceState.synthesisTypeValue) {
        newJson.synthesisType = newResourceState.synthesisTypeValue;
    }
    if (newResourceState.combinationMethodValue) {
        newJson.combinationMethod = newResourceState.combinationMethodValue;
    }
    if (newResourceState.codeValue) {
        newJson.code = newResourceState.codeValue;
    }
    if (newResourceState.content) {
        newJson.content = newResourceState.content;
    }
    if (newResourceState.characteristic) {
        newJson.characteristic = newResourceState.characteristic;
    }
    return newJson;
}

export default createJsonForNewResource;